export { Pill } from './Pill';
export { type PillProps } from './Pill.types';
